/* eslint-disable import/order */
// react-select props override
import Select from './components/Select';

// Components
import { components } from 'react-select';
import Creatable from 'react-select/creatable';
import Async from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';

// Containers
import withAsyncResource from './containers/withAsyncResource';
import withFetchAsyncResource from './containers/withAsyncResource/withFetchAsyncResource';
import withAsyncSelect from './containers/withAsyncSelect';
import withSingleSelect from './containers/withSingleSelect';
import withBaseSelect from './containers/withBaseSelect';
import withTags from './containers/withTags';
import withAsyncTags from './containers/withTags/withAsyncTag';
import withGroupedDynamicAsyncSelect from './containers/withGroupedDynamicAsyncSelect';
var AsyncCreatableSelect = withAsyncResource(AsyncCreatable);
var CreatableSelect = withBaseSelect(Creatable);
var AsyncSelect = withAsyncResource(Async);
var BaseSelect = withBaseSelect(Select);
var SingleSelect = withSingleSelect(BaseSelect);
var AdvanceAsyncSelect = withFetchAsyncResource(withAsyncSelect(Select));
var AdvanceCreatableAsyncSelect = withFetchAsyncResource(withAsyncSelect(Creatable));
var CreatableSelectWithTags = withTags(CreatableSelect);
var AsyncSelectWithTags = withFetchAsyncResource(withAsyncSelect(withAsyncTags(Select)));
var GroupedDynamicAsyncSelect = withAsyncSelect(withGroupedDynamicAsyncSelect(Select));
export { components };
export { AsyncCreatableSelect as AsyncCreatable };
export { AsyncSelect };
export { CreatableSelect as Creatable };
export { AsyncSelect as Async };
export { BaseSelect as Select };
export { SingleSelect };
export { AdvanceAsyncSelect };
export { AdvanceCreatableAsyncSelect };
export { AsyncSelectWithTags };
export { CreatableSelectWithTags as CreatableWithTags };
export { Select as NativeSelect };
export { Creatable as NativeCreatableSelect };
export { GroupedDynamicAsyncSelect };